// ApiError is raised for non-200 responses. It contains the response status code and the response body.

export class ApiError extends Error {
  protected statusCode: number;
  protected body: string;

  constructor(statusCode: number, body: string) {
    super();
    this.statusCode = statusCode;
    this.body = body;
  }

  getStatusCode() {
    return this.statusCode;
  }

  getBody() {
    try {
      return JSON.parse(this.body);
    } catch (e) {
      return null;
    }
  }
}
